import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import {
  AddOrEditFaqRequestSchema,
  DeleteSubAdminsRequest,
  ToggleSubAdminStatusRequest,
} from '.././client-sdk/api';

export const useFaqApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createFaq = useCallback(
    async (addFaqData: AddOrEditFaqRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.addFaq(addFaqData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getAllFAQs = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await api.getAllFaqs(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          searchParam
        );
        return response;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getBlockUnblockFaq = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleStatusFaq: ToggleSubAdminStatusRequest = {
          ids: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
          // data: undefined,
        };
        const response = await api.toggleFaqsStatus(toggleStatusFaq);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getDeleteFaqs = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteFaqs: DeleteSubAdminsRequest = {
          ids: query,
        };
        const response = await api.deleteFaqs(deleteFaqs);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getEditFaqs = useCallback(
    async (faqId: any, faqData: AddOrEditFaqRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.editFaq(faqId, faqData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    createFaq,
    getAllFAQs,
    loading,
    error,
    getBlockUnblockFaq,
    getDeleteFaqs,
    getEditFaqs,
  };
};
